import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { AmplifyApiService } from 'src/app/core/services/amplify-api.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import {
  DeleteMetadataSuccess,
  LoadMetadataSuccess,
  SaveMetadataComplete,
  SaveMetadataFail,
  UpdateMetadataSuccess
} from 'src/app/features/robot-family-metadata/redux/robot-family-metadata.actions';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ENVIRONMENT } from 'src/environments/environment';
import { RobotFamilyMetadata } from '../../../models/robot-family-metadata';

@Injectable({ providedIn: 'any' })
export class RobotFamilyMetadataService {
  public robot_family_metadata_api = APIS.ROBOTS_FAMILY_METADATA;
  public single_metadata_api = APIS.ROBOTS_SINGLE_FAMILY_METADATA;
  public allKeys: string[] = [];
  public type = 'robot-family-metadata';
  public util = new UtilityService();

  constructor(
    private store: Store,
    private toastrService: NbToastrService,
    private apiService: AmplifyApiService
  ) {}

  public loadMetadataAmplify(reload?) {
    this.apiService
      .get(this.robot_family_metadata_api, `/${ENVIRONMENT.name}/`, {})
      .then((response) => {
        if (reload) {
          this.toastrService.show(status, 'Fetching Metadata Complete', {
            status: 'success'
          });
        }
        this.store.dispatch(new LoadMetadataSuccess(response));
      })
      .catch((error) => {
        console.error(error);
        this.toastrService.show(status, 'Fetching Metadata Failed', {
          status: 'danger'
        });
      });
  }

  public postMetadataAmplify(newMetadata: RobotFamilyMetadata) {
    this.apiService
      .post(this.robot_family_metadata_api, `/${ENVIRONMENT.name}/`, { body: newMetadata })
      .then((response) => {
        this.store.dispatch(new SaveMetadataComplete(response));
      })
      .catch((error) => {
        this.store.dispatch(new SaveMetadataFail(error));
      });
  }

  public updateMetadataAmplify(newMetadata: RobotFamilyMetadata) {
    this.apiService
      .put(this.robot_family_metadata_api, `/${ENVIRONMENT.name}/`, { body: newMetadata })
      .then((response) => {
        this.store.dispatch(new UpdateMetadataSuccess(response));
      })
      .catch((error) => {
        console.error(error);
        const message = this.util.convertErrorToMessage(error);
        this.toastrService.show(status, 'Updating Metadata Failed: ' + message, {
          status: 'danger'
        });
      });
  }

  public deleteMetadataAmplify(metadata: RobotFamilyMetadata) {
    this.apiService
      .delete(this.single_metadata_api, `/${ENVIRONMENT.name}/${metadata.robot_family}`, { body: metadata })
      .then(() => {
        this.toastrService.show(status, 'Deleted Metadata Record', {
          status: 'success'
        });
        this.store.dispatch(new DeleteMetadataSuccess(metadata));
      })
      .catch((error) => {
        console.error(error);
        const message = this.util.convertErrorToMessage(error);
        this.toastrService.show(status, 'Deleting Metadata Failed - ' + message, {
          status: 'danger'
        });
      });
  }
}
